"use client";

import React from "react";
import { LayoutGrid, Sparkles, Archive } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface PlanningCard {
  id: string;
  title: string;
  description: string;
  icon: React.ComponentType<{
    className?: string;
    "aria-hidden"?: boolean | "true" | "false";
  }>;
}
const planningCards: PlanningCard[] = [{
  id: "sma-badrum",
  title: "Smarta lösningar för små badrum",
  description: "Även ett litet badrum kan kännas rymligt med rätt planering. Vägghängd inredning frigör golvyta, medan vikbara duschväggar och smart placerade nischer gör det lättare att utnyttja varje kvadratmeter.",
  icon: LayoutGrid
}, {
  id: "stora-badrum",
  title: "Mer rymd och funktion i stora badrum",
  description: "I ett större badrum finns möjlighet att kombinera komfort med praktiska lösningar. Dubbelhandfat, ett fristående badkar eller en separat duschzon kan skapa en genomtänkt helhet där både vardagsrutiner och avkoppling får plats.",
  icon: Sparkles
}, {
  id: "dold-forvaring",
  title: "Dold förvaring för ett harmoniskt badrum",
  description: "Integrerade spegelskåp, diskreta lådor och hyllnischer hjälper dig att hålla ordning utan att kompromissa med designen. Med genomtänkt förvaring får badrummet ett lugnare uttryck och blir enklare att använda varje dag.",
  icon: Archive
}];
export default function SmartPlaneringBadrum() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="smart-planering" className="bg-muted/40 text-foreground py-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto" ref={ref}>
        <div className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="text-center mb-16">
            <h2 className="font-default text-3xl md:text-5xl font-semibold text-foreground tracking-tight">
              Smart planering för små och stora badrum
            </h2>
            <div className="mt-4 h-1 w-20 bg-primary mx-auto rounded-full" />
            <p className="mt-6 max-w-3xl mx-auto text-muted-foreground text-base md:text-lg leading-relaxed">
              Ett välplanerat badrum handlar om mer än utseendet. Med genomtänkta lösningar kan du skapa både funktion, förvaring och en harmonisk känsla – oavsett hur stor yta du har. Här är några idéer som hjälper dig att ta vara på badrummets möjligheter.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 items-stretch">
            {planningCards.map((card, index) => {
            const Icon = card.icon;
            const isLastOnTablet = index === 2;
            return <article key={card.id} className={`bg-card text-card-foreground border border-border/60 rounded-xl p-8 flex flex-col h-full shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 ${isLastOnTablet ? "md:col-span-2 lg:col-span-1" : ""}`}>
                  <div className="w-12 h-12 rounded-lg bg-primary/10 text-primary flex items-center justify-center mb-6 shrink-0">
                    <Icon className="w-6 h-6" aria-hidden="true" />
                  </div>
                  <h3 className="font-default text-xl font-semibold text-foreground mb-3">
                    {card.title}
                  </h3>
                  <p className="text-muted-foreground text-sm md:text-base leading-relaxed grow">
                    {card.description}
                  </p>
                </article>;
          })}
          </div>
        </div>
      </div>
    </section>;
}